import React from 'react';
import {
  compose,
  withProps,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import { FormattedMessage } from 'react-intl';
import { FilterCheckbox, ReduxFormFilterCheckbox } from './Checkbox';
import { Field } from 'redux-form';
import { getStyles, percentage } from '@ux/style-utils';
import { gu2px } from '@ux/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import * as r from 'ramda';
import { tldToFormName } from '../../../domain/tld/utils';

export const stylesheet = ({
  theme,
}) => {
  const {
    spacing,
  } = theme;
  return {
    default: {
      root: {
        ...cssSides('padding', Side.A, 0),
        ...cssSides('margin', Side.A, 0),
        listStyle: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        marginLeft: -(gu2px(1, spacing)),
        overflow: 'hidden',
      },
      item: {
        width: percentage(50),
        paddingLeft: gu2px(1, spacing),
        paddingBottom: gu2px(1, spacing),
      },
    },

    isMinSm: {
      item: {
        width: percentage(25),
      },
    },

    isMinMd: {
      root: {
        justifyContent: 'flex-end',
        flexWrap: 'nowrap',
      },
      item: {
        width: 'auto',
        paddingBottom: 0,
      },
    },
  };
};

export const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  isMinSm: props.isMinSm,
  isMinMd: props.isMinMd,
});

export const PureFilterTLD = ({
  styles,
  theme,
  allChecked,
  onAllTldsChange,
  tlds,
  isMinLg,
}) => (
  <ul style={styles.root}>
    <li style={styles.item}>
      <FilterCheckbox
        id="dstFiltersTldAll"
        theme={theme}
        name="tld.__all__"
        checked={allChecked}
        onChange={onAllTldsChange}
        label={(<FormattedMessage id="dst.filters.tlds.all"/>)}
      />
    </li>
    {r.map((tld) => (
      <li
        key={tld}
        style={styles.item}
      >
        <Field
          name={`tld.${tldToFormName(tld)}`}
          component={ReduxFormFilterCheckbox}
          isMinLg={isMinLg}
          theme={theme}
          pin={`dstFiltersTld${tld}`}
          label={tld}
        />
      </li>
    ))(tlds)}
  </ul>
);

export const enhance = compose(
  setDisplayName('FilterTLD'),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureFilterTLD);
